import { useRegionListData } from '../contexts/RegionListContext'
import type { Region } from '../SelectRegion'
import { useRouter } from 'next/router'

export const useRegions = () => {
	const router = useRouter()
	const regionListData = useRegionListData()

	const regions: Array<Region> = regionListData
		.filter(region => region.label !== undefined)
		.map(region => ({
			id: region.id,
			name: region.label || '',
			code: region.code,
			currency: region.currency || { identifier: '', rateAgainstCzk: 0, sign: '', signAlignment: 'left' },
		}))

	const currentRegionCode = (router.query.region as string) || undefined

	return {
		regions,
		currentRegionCode,
	}
}
